/** Domestic codes/names: https://www.deliveryapi.co.kr/docs#introduction (2026-10-08).
 * Reconcile with authenticated /v1/tracking/couriers before live integration.
 * null means no verified official lookup URL; consumers display courier/number instead.
 */
export const ORDER_COURIERS = [
  {
    code: 'lotte',
    name: '롯데택배',
    trackingUrlTemplate: 'https://www.lotteglogis.com/home/reservation/tracking/index',
  },
  {
    code: 'cj',
    name: 'CJ대한통운',
    trackingUrlTemplate: 'https://www.cjlogistics.com/ko/tool/parcel/tracking',
  },
  {
    code: 'hanjin',
    name: '한진택배',
    trackingUrlTemplate:
      'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnum={trackingNumber}',
  },
  {
    code: 'post',
    name: '우체국택배',
    trackingUrlTemplate: 'https://service.epost.go.kr/iservice/usr/trace/usrtrc001k01.jsp',
  },
  { code: 'kyungdong', name: '경동택배', trackingUrlTemplate: null },
  { code: 'daesin', name: '대신택배', trackingUrlTemplate: null },
  {
    code: 'logen',
    name: '로젠택배',
    trackingUrlTemplate: 'https://www.ilogen.com/web/personal/tkSearch',
  },
  { code: 'hapdong', name: '합동택배', trackingUrlTemplate: null },
  { code: 'coupang', name: '쿠팡택배', trackingUrlTemplate: null },
  { code: 'woori', name: '우리택배', trackingUrlTemplate: null },
  { code: 'cupost', name: 'CU편의점택배', trackingUrlTemplate: null },
  { code: 'gspostbox', name: 'GS편의점택배', trackingUrlTemplate: null },
  { code: 'lottedept', name: '롯데백화점택배', trackingUrlTemplate: null },
  { code: 'chunil', name: '천일택배', trackingUrlTemplate: null },
] as const;
export type OrderCourierCode = (typeof ORDER_COURIERS)[number]['code'];

export function getOrderTrackingUrl(courierCode: string, trackingNumber: string): string | null {
  if (!/^[0-9]{6,30}$/.test(trackingNumber)) return null;
  const template = ORDER_COURIERS.find(
    (courier) => courier.code === courierCode,
  )?.trackingUrlTemplate;
  return template?.replace('{trackingNumber}', encodeURIComponent(trackingNumber)) ?? null;
}
